import { render, staticRenderFns } from "./PretestResults.vue?vue&type=template&id=a6b9421c&scoped=true"
import script from "./PretestResults.vue?vue&type=script&lang=js"
export * from "./PretestResults.vue?vue&type=script&lang=js"
import style0 from "./PretestResults.vue?vue&type=style&index=0&id=a6b9421c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b9421c",
  null
  
)

export default component.exports